import React from 'react';
import { motion } from 'framer-motion';

const StarfieldBackground = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {/* Removed the radial gradient background, as the App.js now sets a solid black background */}
      
      {/* Linear moving stars */}
      {Array.from({ length: 200 }).map((_, i) => { // Increased star count for density
        const size = Math.random() * 2 + 0.5; // Star size
        const animationDuration = 3 + Math.random() * 5; // Speed of stars
        const delay = Math.random() * 5; // Staggered entry

        // Random starting position, mostly from the center to simulate perspective
        const startX = Math.random() * 100;
        const startY = Math.random() * 100;

        return (
          <motion.div
            key={`linear-star-${i}`}
            className="absolute bg-white rounded-full"
            style={{
              width: size,
              height: size,
              left: `${startX}%`,
              top: `${startY}%`,
              opacity: 0, // Start invisible
            }}
            animate={{
              opacity: [0, 0.8, 0], // Fade in and out
              scale: [0.5, 2, 0.5], // Grow as it approaches
              // Simulate moving directly towards the camera from a random point
              // Stars will appear to move outwards from the center as they approach
              x: [`${startX}%`, `${(startX - 50) * 2 + 50}%`], // Move outwards from center X
              y: [`${startY}%`, `${(startY - 50) * 2 + 50}%`], // Move outwards from center Y
            }}
            transition={{
              duration: animationDuration,
              repeat: Infinity,
              ease: "linear",
              delay: delay,
            }}
          />
        );
      })}
    </div>
  );
};

export default StarfieldBackground;